import React, { useState } from "react";
import { MdNotifications } from "react-icons/md";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import CollaboratorInitialModalScheduling from "../collaboratorInitial/CollaboratorInitialSchedulingModal";
import { ButtonMarkConsulta } from "../../pages/collaboratorInitial/CollaboratorInitial.styled";
import { FilledButton } from "../UI/buttons/Button";

const MarkConsultButton: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const { isTablet } = useResponsiveInfo();

  return (
    <>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-end", gap: "12px" }}>
        <ButtonMarkConsulta
          color="#0a5190"
          onClick={() => setShowModal(true)}
          disabled={false}
          isTablet={isTablet}
        >
          Marcar consulta
        </ButtonMarkConsulta>
        {!isTablet && (
          <FilledButton color="#F0F9FF" onClick={() => {}} disabled={false}>
            <MdNotifications style={{ color: "#0A5190" }} size={20} />
          </FilledButton>
        )}
      </div>

      <CollaboratorInitialModalScheduling
        modalOpen={showModal}
        onCloseModal={() => setShowModal(false)}
      />
    </>
  );
};

export default MarkConsultButton;
